import React from "react";
import { A11Y_ANNOUNCER_ID } from "../../helper/a11yAnnouncements";

export const RegistrationA11yAnnouncer = () => (
  <div
    id={A11Y_ANNOUNCER_ID}
    aria-live="polite"
    aria-atomic="true"
    className="registration-sr-only"
  />
);
